var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hooper',{style:({ height: 'auto' }),attrs:{"settings":_vm.hooperSettings}},[_vm._l((_vm.pictures),function(picture,index){return _c('slide',{key:index},[_c('div',{staticClass:"slider_responsive",style:({
        'background-image': `url(${_vm.$imgUrl(picture)})`,
      })})])}),(_vm.pictures.length > 1)?_c('hooper-pagination',{attrs:{"slot":"hooper-addons"},slot:"hooper-addons"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }